import React, { useMemo, useState } from "react";
import { Row, Col } from "react-bootstrap";
import DocumentUploadCard from "../../../components/CustomControls/DocumentUpload/DocumentUploadCard";
import { Card } from "../../../components/Cards/Card";
import { CustomSelect } from "../../../components/CustomControls/CustomSelect";
import { useTranslation } from "react-i18next";
import BootstrapTable from "react-bootstrap-table-next";
import { Add } from "../../../components/Icons/Icons";
import LinkBox from "../../../components/CustomControls/LinkBox";
import { ModalCreateVendor } from "../../../components/ClinicalTrials/ModalCreateVendor";
import {
  attachmentCategories,
  attachmentEntityType,
} from "../../../variables/Enums";
import { useAuthorization } from "../../../components/Authorization/useAuthorization";

export const ActivateCenter = (props) => {
  const { t } = useTranslation();
  const [, , isAuthorized] = useAuthorization();
  const [showModal, setShowModal] = useState(false);
  const { startup, setStartup, handleAttachmentChange, onSaveStartup } = props;

  const files = useMemo(() => {
    const map = {};
    if (startup?.attachments?.length) {
      startup.attachments.forEach((att) => {
        map[att.attachmentCategoryId] = att;
      });
    }
    return map;
  }, [startup?.attachments]);

  const onChangeFilter = (name, value) => {
    onSaveStartup(value.value);
  };

  const handleChange = (key, value) => {
    setStartup((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const getStatusOptions = () => {
    switch (startup?.protocol.status.code) {
      case "StartUp":
        return ["Recruiting", "OnHold", "OnGoing", "Closed"].map((status) => ({
          value: status,
          label: t(`clinicalTrials.statuses.${status}`),
        }));
      case "Recruiting":
        return ["OnHold", "OnGoing", "Closed"].map((status) => ({
          value: status,
          label: t(`clinicalTrials.statuses.${status}`),
        }));
      case "OnGoing":
        return ["Recruiting", "OnHold", "Closed"].map((status) => ({
          value: status,
          label: t(`clinicalTrials.statuses.${status}`),
        }));
      case "OnHold":
        return ["Recruiting", "OnGoing", "Closed"].map((status) => ({
          value: status,
          label: t(`clinicalTrials.statuses.${status}`),
        }));
      default:
        break;
    }
  };

  const vendorColumns = [
    { dataField: "name", text: "Nombre" },
    {
      dataField: "link",
      text: "Link",
      formatter: (cell) => (
        <a href={cell} target="_blank" rel="noopener noreferrer">
          {cell}
        </a>
      ),
    },
    {
      dataField: "actions",
      isDummyField: true,
      text: "",
      formatter: (_, __, rowIndex) => (
        <span
          style={{ cursor: "pointer", color: "#dc3545", fontSize: "16px" }}
          onClick={() => handleDeleteVendor(rowIndex)}
          title={t("clinicalTrials.startup.deleteVendorColumnLabel")}
        >
          <i className="fa fa-trash" />
        </span>
      ),
      headerStyle: { width: "50px", textAlign: "center" },
      align: "center",
    },
  ];

  const handleAddVendor = (newVendor) => {
    setStartup((prev) => ({
      ...prev,
      vendors: [...(prev.vendors || []), newVendor],
    }));
  };

  const handleDeleteVendor = (indexToDelete) => {
    setStartup((prev) => ({
      ...prev,
      vendors: (prev.vendors || []).filter(
        (_, index) => index !== indexToDelete
      ),
    }));
  };

  return (
    <>
      <Card
        content={
          <div style={{ whiteSpace: "nowrap" }}>
            <div
              style={{
                display: "inline-block",
                verticalAlign: "middle",
                marginRight: "24px",
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  marginBottom: "2px",
                }}
              >
                {t("clinicalTrials.startup.currentStatusLabel")}
              </div>
            </div>

            <div style={{ width: "40px", display: "inline-block" }} />

            <div
              style={{
                display: "inline-block",
                verticalAlign: "middle",
                marginRight: "8px",
                color: "#6c757d",
                fontSize: "14px",
              }}
            >
              {t("clinicalTrials.startup.switchStatusLabel")}:
            </div>

            <div
              style={{
                display: "inline-block",
                verticalAlign: "middle",
                minWidth: "200px",
              }}
            >
              <CustomSelect
                value={{
                  label: t(
                    `clinicalTrials.statuses.${startup?.protocol?.status?.code}`
                  ),
                  value: startup?.protocol?.status?.code,
                }}
                name="status"
                onChange={onChangeFilter}
                isMulti={false}
                isClearable={false}
                loading={false}
                options={getStatusOptions()}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
              />
            </div>
          </div>
        }
      />
      <Row>
        {files[attachmentCategories.flowchartSOA] && (
          <Col md={12}>
            <Card
              content={
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  protocolId={startup?.protocol?.id}
                  attachment={files[attachmentCategories.flowchartSOA]}
                  legend={"Documento Flowchart SOA"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!isAuthorized(["Startups.Edit"])}
                />
              }
            />
          </Col>
        )}
      </Row>
      <Row>
        <Col md={12}>
          <Card
            content={
              <LinkBox
                title="IWRS (Interactive Web Response System)"
                subtitle="Pega el Link de la plataforma"
                value={startup?.iwrsLink || ""}
                onChange={(newLink) => handleChange("iwrsLink", newLink)}
              />
            }
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card
            content={
              <LinkBox
                title="Case report form (CRF)"
                subtitle="Pega el Link de la plataforma"
                value={startup?.crfLink || ""}
                onChange={(newLink) => handleChange("crfLink", newLink)}
              />
            }
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card
            content={
              <LinkBox
                title="Informed Consent form"
                subtitle={t("clinicalTrials.startup.linkboxTooltip")}
                value={startup?.consentLink || ""}
                onChange={(newLink) => handleChange("consentLink", newLink)}
              />
            }
          />
        </Col>
      </Row>
      {/* <Row>
        <Col md={12}>
          <Card
            content={
              <LinkBox
                title="Serious Adverse Events (SAEs)"
                subtitle="Pega el Link de la plataforma"
                value={startup?.saeLink || ""}
                onChange={(newLink) => handleChange("saeLink", newLink)}
              />
            }
          />
        </Col>
      </Row> */}
      <Row>
        {files[attachmentCategories.elegibilityForm] && (
          <Col md={12}>
            <Card
              content={
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  protocolId={startup?.protocol?.id}
                  attachment={files[attachmentCategories.elegibilityForm]}
                  legend={"Subir documento"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!isAuthorized(["Startups.Edit"])}
                />
              }
            />
          </Col>
        )}
      </Row>
      <Row>
        {files[attachmentCategories.recistTable] && (
          <Col md={12}>
            <Card
              content={
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  protocolId={startup?.protocol?.id}
                  attachment={files[attachmentCategories.recistTable]}
                  legend={"Subir documento"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!isAuthorized(["Startups.Edit"])}
                />
              }
            />
          </Col>
        )}
      </Row>
      <Row>
        <Col md={12}>
          <Card
            content={
              <>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    marginBottom: "2px",
                  }}
                >
                  {t("clinicalTrials.startup.vendorsLabel")}
                </div>
                <BootstrapTable
                  keyField="name"
                  data={startup?.vendors || []}
                  columns={vendorColumns}
                  bordered={false}
                  classes="table-spaced table-spaced-small"
                  wrapperClasses="table-responsive"
                  noDataIndication={() => (
                    <>{t("clinicalTrials.startup.noVendorsMessage")}</>
                  )}
                />
                <button
                  type="button"
                  className="btn btn-primary mt-2"
                  onClick={() => setShowModal(true)}
                >
                  <Add /> {t("clinicalTrials.startup.addVendorLabel")}
                </button>

                <ModalCreateVendor
                  show={showModal}
                  onClose={() => setShowModal(false)}
                  onSave={handleAddVendor}
                />
              </>
            }
          />
        </Col>
      </Row>
      <Row>
        {files[attachmentCategories.newsletters] && (
          <Col md={12}>
            <Card
              content={
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  protocolId={startup?.protocol?.id}
                  attachment={files[attachmentCategories.newsletters]}
                  legend={"Subir documento"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!isAuthorized(["Startups.Edit"])}
                />
              }
            />
          </Col>
        )}
        {files[attachmentCategories.acts] && (
          <Col md={12}>
            <Card
              content={
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  protocolId={startup?.protocol?.id}
                  attachment={files[attachmentCategories.acts]}
                  legend={"Documentación de la resolución"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!isAuthorized(["Startups.Edit"])}
                />
              }
            />
          </Col>
        )}
      </Row>
      <Row>
        {files[attachmentCategories.recruitmentClosure] && (
          <Col md={12}>
            <Card
              content={
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  protocolId={startup?.protocol?.id}
                  attachment={files[attachmentCategories.recruitmentClosure]}
                  legend={"Subir documento"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!isAuthorized(["Startups.Edit"])}
                />
              }
            />
          </Col>
        )}
      </Row>
      <Row>
        {files[attachmentCategories.closingVisit] && (
          <Col md={12}>
            <Card
              content={
                <>
                  <DocumentUploadCard
                    attachmentEntityTypeId={attachmentEntityType.Startup}
                    entityId={startup?.id}
                  protocolId={startup?.protocol?.id}
                    attachment={startup?.attachments.find(
                      (x) =>
                        x.attachmentCategoryId ===
                        attachmentCategories.closingVisit
                    )}
                    legend={"Subir documento"}
                    onAttachmentChange={handleAttachmentChange}
                  />
                </>
              }
            />
          </Col>
        )}
      </Row>
    </>
  );
};

export default ActivateCenter;
